import HelikaSDK, { EventsBaseURL } from 'helika-sdk';

type EventDetails = {
  event_label: string;
  event_action: string;
};

export type HelikaEvent = {
  event_type: HELIKA_EVENT_TYPE;
  event: {
    event_sub_type: string;
    event_details: EventDetails;
    submission_id?: string;
    opinion_id?: string;
    profile_id?: string;
    poll_id?: string;
    day_number?: number;
    task_id?: string;
    task_name?: string;
    utm?: string;
    tournament_id?: string;
  };
};

class HelikaService {
  public helikaSDK: InstanceType<typeof HelikaSDK.EVENTS> | null = null;

  constructor() {
    this.init();
  }

  private getEventsBaseURL(): EventsBaseURL {
    if (import.meta.env.MODE === 'development')
      return EventsBaseURL.EVENTS_LOCAL;
    return import.meta.env.VITE_IS_STAGING
      ? EventsBaseURL.EVENTS_DEV
      : EventsBaseURL.EVENTS_PROD;
  }

  public async init(): Promise<void> {
    if (this.helikaSDK) return;

    try {
      this.helikaSDK = new HelikaSDK.EVENTS(
        import.meta.env.VITE_HELIKA_API_KEY,
        import.meta.env.VITE_HELIKA_GAME_ID,
        this.getEventsBaseURL(),
      );

      this.helikaSDK.setAppDetails({
        platform_id: 'TMA',
        client_app_version: '1.3.18',
        server_app_version: '1.1.14',
        store_id: 'telegram',
      });

      await this.helikaSDK.startSession();

      console.log('Helika initialized');
    } catch (error) {
      console.error('Helika initialization failed:', error);
    }
  }

  public async sendEvent(event: HelikaEvent): Promise<void> {
    if (!this.helikaSDK) {
      console.error('Helika SDK is not initialized');
      return;
    }

    try {
      const response: unknown = await this.helikaSDK.createUserEvent([event]);

      console.log('Event sent successfully:', response);
    } catch (error) {
      console.error('Failed to send event:', error);
    }
  }
}

export const helika = new HelikaService();

export enum HELIKA_EVENT_TYPE {
  UI = 'ui',
  GAMEPLAY = 'gameplay',
  LOADING = 'loading',
  FEATURE = 'feature',
}
